const columns = [
	{
		label: 'Process ID',
		msgKey: 'SWCC000284',
		prop: 'procId',
		custom: true
	},
	{
		label: 'Process Name',
		msgKey: 'SWCC000285',
		prop: 'procName'
	},
	{
		label: '서비스',
		msgKey: 'SWCC000250',
		prop: 'serviceKind'
	},
	{
		label: 'Type',
		msgKey: 'SWCC000315',
		prop: 'procType'
	},
	{
		label: 'Kind',
		msgKey: 'SWCC000314',
		prop: 'procKind'
	}
];

export default columns;
